
import * as React from 'react';

interface IProps {
    smallLoad?: boolean,
    inlineLoader?: boolean
}

export const LoadingAnimation: React.FunctionComponent<IProps> = (props: IProps) => (
    <React.Fragment>
        {!props.inlineLoader && <div className="loading-content" style={props.smallLoad ? { display: 'none' } : {}}>
            <div className="progress-indicator" />
        </div>}
        {props.inlineLoader && <div className="progress-indicator progress-indicator-inline" />}
    </React.Fragment>
);